import Element451ReaderNode from './types/element451-reader';
import Element451WriterNode from './types/element451-writer';

export const element451Nodes = {
  element451Reader: Element451ReaderNode,
  element451Writer: Element451WriterNode,
};
